import React from 'react';
import { Play } from 'lucide-react';

const VideoBanner = () => {
  return null;
};

export default VideoBanner;